import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { CoreData } from '../../core-data/core-data';
import { LoadingTask } from '../loading-task';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-export-box',
    templateUrl: './export-box.html',
    styleUrls: ['./export-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportBoxDialog extends BaseComponent implements OnInit {

    SelectedYear: string;
    YearList: string[] = ['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
    SelectedMonth: string;
    MonthList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    constructor(
        protected coreData: CoreData,
        public LoadingTask: LoadingTask,
        public dialogRef: MatDialogRef<ExportBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {
        super(coreData)

    }

    ngOnInit() {

    }

    getMonthLabel(month: number) {
        return StringConverter.getMonthName(month)
    }

    CanAdd() {
        return this.SelectedYear && this.SelectedMonth;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {

        if (!this.CanAdd())
            return;

        this.dialogRef.close({ Year: this.SelectedYear, Month: this.SelectedMonth });
    }

    public compareWith(m1: ClientMeasure, m2: ClientMeasure) {
        return m1 && m2 ? m1.ParentName === m2.ParentName : m1 === m2;
    }
}
